import { FormField } from './field';
import { FieldControl } from '@signature-it/ngx-generic/enums';

export class PercentageField extends FormField {
    controlType = FieldControl.PERCENTAGE;
}
